/**
 * 이 화면이 **언제 만든 빌드인가** — 화면 맨 아래 줄과 도움말 「정보」 에 보인다.
 *
 * 현장에 깔린 스탠드얼론이 어느 빌드인지 몰라, 이미 고친 문제를 다시 신고받는 일이 있었다(2026-09-29).
 * 값은 `npm run build` 의 prebuild(scripts/write-release.js)가 .env.local 에 박는다.
 * 개발 서버(npm start)는 소스를 그때그때 반영하므로 빌드 시각이 없다 — 「개발 서버」 로 적는다.
 */
import i18n from '../i18n';
import { formatDateTime } from '../utils/formatters';

export const BUILD_TIME = process.env.REACT_APP_BUILD_TIME || '';
export const BUILD_RELEASE = process.env.REACT_APP_RELEASE || '';
export const IS_DEV_SERVER = process.env.NODE_ENV === 'development';

/** "2026-09-17 10:23" · 개발 서버면 "개발 서버" · 모르면 "-" */
export function buildTimeText(): string {
  if (IS_DEV_SERVER) return i18n.t('layout:build.devServer');
  return BUILD_TIME ? formatDateTime(BUILD_TIME, { seconds: false }) : '-';
}

/** 맨 아래 줄 한 토막 — "빌드 2026-09-17 10:23 (4ef5e9f)" */
export function buildLabel(): string {
  if (IS_DEV_SERVER) return i18n.t('layout:build.devServer');
  const rel = BUILD_RELEASE ? ` (${BUILD_RELEASE})` : '';
  return i18n.t('layout:build.label', { time: buildTimeText(), release: rel });
}
